import { Col, Container, ListGroup, ListGroupItem, Row } from "react-bootstrap";
import AIediting from '../resources/AI-editing.jpg'
import Evoluation from '../resources/the-evoluation.jpg'
import Grammer from '../resources/beyond-grammer.jpg'
import Future from '../resources/the-future-ai.jpg'
import NLP from '../resources/using-nlp.jpg'
import Generate from '../resources/genrate-ai.jpg'
import Mastery from '../resources/multilingual-mastery.jpg'
import Gammer from '../resources/powered-gammer.jpg'
import { Helmet, HelmetProvider } from 'react-helmet-async';
export function Blog() {

	return (
		<>
			<HelmetProvider>
				<Helmet>
					<title>EnglishEditAI Blog</title>
					<meta name="description" content="Find out more about the exciting field of AI assisted editing. Learn about the past, present, and get a glimpse into the thrilling future that lies ahead."></meta>
				</Helmet>
			</HelmetProvider>
			{/* Blog Container Start Here */}
			{/* <Container> */}
			{/* Blog Heading Start Here */}
			<Row>
				<Col className="text-center mb-2">
					<h1>Blog</h1>
				</Col>
			</Row>
			{/* Blog Heading End Here */}
			<Row className="mt-sm-0 mt-3">
				{/* Blog card Start Here */}
				<Col className="col-12 col-md-6 col-lg-3">
					<a href='/AI_Based_Editing_Versus_Traditional_Human_Editing' className="text-deco-none">
						<div className="card border-0 blog-card mb-5">
							<div className="card-image">
								<img src={AIediting} alt="" className="w-100" />
							</div>
							<div className="card-body p-0 mt-3">
								<h4>AI-Based Editing Versus Traditional Human Editing </h4>

							</div>
						</div>
					</a>
				</Col>
				<Col className="col-12 col-md-6 col-lg-3">
					<a href="/The_Evolution_of_AI_Assisted_Editing_Over_the_Past_Decade" className="text-deco-none">
						<div className="card border-0 blog-card mb-5">
							<div className="card-image">
								<img src={Evoluation} alt="" className="w-100" />
							</div>
							<div className="card-body p-0 mt-3">
								<h4>The Evolution of AI-Assisted Editing Over the Past Decade</h4>

							</div>
						</div>
					</a>
				</Col>
				<Col className="col-12 col-md-6 col-lg-3">
					<a href="/Beyond_Grammar-How_AI_Understands_and_Enhances_Tone_and_Style_in_Writing" className="text-deco-none">
						<div className="card border-0 blog-card mb-5">
							<div className="card-image">
								<img src={Grammer} alt="" className="w-100" />
							</div>
							<div className="card-body p-0 mt-3">
								<h4>Beyond Grammar: How AI Understands and Enhances Tone and Style in Writing</h4>

							</div>
						</div>
					</a>
				</Col>
				<Col className="col-12 col-md-6 col-lg-3">
					<a href="/The_Future_of_AI_in_Editing-Predictions_and_Possibilities_in_the_Next_Decade" className="text-deco-none">
						<div className="card border-0 blog-card mb-5">
							<div className="card-image">
								<img src={Future} alt="" className="w-100" />
							</div>
							<div className="card-body p-0 mt-3">
								<h4>The Future of AI in Editing: Predictions and Possibilities in the Next Decade</h4>

							</div>
						</div>
					</a>
				</Col>
				<Col className="col-12 col-md-6 col-lg-3">
					<a href="/Using_NLP_as_an_Editing_Tool_to_Enhance_A_Technical_Dive" className="text-deco-none">
						<div className="card border-0 blog-card mb-5">
							<div className="card-image">
								<img src={NLP} alt="" className="w-100" />
							</div>
							<div className="card-body p-0 mt-3">
								<h4>Using NLP as an Editing Tool to Enhance Writing: A Technical Deep Dive</h4>

							</div>
						</div>
					</a>
				</Col>
				<Col className="col-12 col-md-6 col-lg-3">
					<a href="/Generative_AI_in_Editing-How_AI_Suggests_and_Rewrites_for_Enhanced_Content_Quality" className="text-deco-none">
						<div className="card border-0 blog-card mb-5">
							<div className="card-image">
								<img src={Generate} alt="" className="w-100" />
							</div>
							<div className="card-body p-0 mt-3">
								<h4>Generative AI in Editing: How AI Suggests and Rewrites for Enhanced Content Quality</h4>

							</div>
						</div>
					</a>
				</Col>
				<Col className="col-12 col-md-6 col-lg-3">
					<a href="/Multilingual_Mastery-AI_s_Role_in_Breaking_Down_Language_Barrier" className="text-deco-none">
						<div className="card border-0 blog-card mb-5">
							<div className="card-image">
								<img src={Mastery} alt="" className="w-100" />
							</div>
							<div className="card-body p-0 mt-3">
								<h4>Multilingual Mastery: AI's Role in Breaking Down Language Barriers</h4>

							</div>
						</div>
					</a>
				</Col>
				<Col className="col-12 col-md-6 col-lg-3">
					<a href="/Powered_Grammar_Checks_Moving_Beyond_Traditional_Spellcheck" className="text-deco-none">
						<div className="card border-0 blog-card mb-5">
							<div className="card-image">
								<img src={Gammer} alt="" className="w-100" />
							</div>
							<div className="card-body p-0 mt-3">
								<h4>Powered Grammar Checks: Moving Beyond Traditional Spellcheck</h4>

							</div>
						</div>
					</a>
				</Col>
				{/* Blog card end Here */}
			</Row>
			{/* </Container> */}
			{/* Blog Container End Here */}
		</>
	)
}